export default "__VITE_ASSET__BW5OSkbc__"